exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":root {\r\n  --appbar-height: 64px;\r\n  --sidedrawer-width: 10rem;\r\n  --footer-height: 160px;\r\n  --padding-left: 1.2rem;\r\n}\r\n\r\n.layout--noUserSelect--TDMRwUMn {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"noUserSelect": "layout--noUserSelect--TDMRwUMn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/styles/layout.css
// module id = 535
// module chunks = 1